import React, { useEffect } from "react";
import { connect } from "react-redux";

import { fetchDrink } from "../../actions";
import Spinner from "../Spinner";

// 'match' from router
const DrinkDetail = ({ match, fetchDrink, drink }) => {
  useEffect(() => {
    fetchDrink(match.params.id);
  }, [fetchDrink, match.params.id]);

  console.log("drink", drink);

  if (!drink) {
    return <Spinner />;
  }

  const { image, name, steps } = drink;

  let imageToUse = image;
  if (!image || image.length <= 1) {
    const placeholder = `${process.env.PUBLIC_URL}/placeholder.png`;
    imageToUse = placeholder;
  }

  const renderSteps = steps => {
    const lines = steps.map(step => {
      return <li>{step}</li>;
    });
    return <ol>{lines}</ol>;
  };

  return (
    <div className="ui segment">
      <div className="ui centered header">{name}</div>
      <img className="ui centered image" src={imageToUse} alt={name} />
      <div className="ui secondary segment">
        <div className="ui description">
          <h4>Steps</h4>
          {renderSteps(steps)}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    drink: state.drink
  };
};

const mapActionsToProps = {
  fetchDrink
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(DrinkDetail);
